import LoaderScreen from "components/Loader";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useUser } from "stores/useUser";
import { notify, refreshUserFromFirestore } from "utils/common";
import { FirebaseAuth, FirestoreDB } from "utils/firebase";

function GoogleOAuthReturnHandler() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setUser } = useUser();
  const [isHandlingOAuthReturn, setIsHandlingOAuthReturn] = useState(false);

  useEffect(() => {
    const status = searchParams.get("google_oauth");
    const message = searchParams.get("message");

    setIsHandlingOAuthReturn(Boolean(status));

    if (!status) {
      return;
    }

    const clearParams = () => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete("google_oauth");
      nextParams.delete("message");
      setSearchParams(nextParams, { replace: true });
    };

    const cleanUrl = (() => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete("google_oauth");
      nextParams.delete("message");
      const query = nextParams.toString();
      return `${location.pathname}${query ? `?${query}` : ""}${location.hash}`;
    })();

    if (status === "success") {
      refreshUserFromFirestore(FirebaseAuth, FirestoreDB)
        .then((userData) => {
          if (!userData) {
            throw new Error("Failed to refresh calendar connection.");
          }

          setUser(userData);
          notify("Calendar connected successfully!", "success");
          window.location.replace(
            location.pathname === "/onboarding-calendar" ? "/" : cleanUrl,
          );
        })
        .catch((error) => {
          console.error("Google OAuth refresh error:", error);
          notify(error.message || "Failed to refresh calendar connection.", "error");
          setIsHandlingOAuthReturn(false);
          clearParams();
        });

      return;
    }

    if (message) {
      notify(message, "error");
    }

    setIsHandlingOAuthReturn(false);
    clearParams();
  }, [location.hash, location.pathname, searchParams, setSearchParams, setUser]);

  if (!isHandlingOAuthReturn) {
    return null;
  }

  return (
    <LoaderScreen
      title="Finalizing Google Calendar connection"
      subtitle="Syncing your account and reloading the workspace"
    />
  );
}

export default GoogleOAuthReturnHandler;
